module.exports = __webpack_public_path__ + "static/media/warehouse.84286ebd.svg";